/**
 * AmbientBackground
 *
 * Previously rendered dark atmospheric blobs/noise/grid.
 * Now a no-op — kept as an empty export to avoid breaking imports.
 */
export function AmbientBackground() {
  return null;
}
